import Env from './env.js';
import Dom from '../base/mdom.js';
import * as Util from '../common/util.js';
import mweixin from '../report/report_base.js';
import UiSrc from '../common/uiutil.src.js';
import UiPop from '../common/uiutil.popup.src.js';

var oldUI = Util.extend(UiSrc, UiPop);
let exportData;
if(!Env.isCSR) {
    (function (newUI) {

        var isNeedLock = isNeedLockBodyHeight();
        var isShowing = false;
        var currLockType = ""; // alert 或 loading 或 alert&loading
        var stBeforeLock = 0;  // 锁高度之前，屏幕的高度
        newUI.alert = function (str, cfg) {
            cfg = cfg || {};
            var newCfg = Util.extend(cfg, {});
            if (isNeedLock) {
                lockScreen("alert");
                newCfg.confirmCb = function () {
                    unlockScreen("alert");
                    cfg.confirmCb && cfg.confirmCb();
                };
                newCfg.closeCb = function () {
                    unlockScreen("alert");
                    cfg.closeCb && cfg.closeCb();
                };
    
            }
            oldUI.alert(str, newCfg);
        }
        newUI.closeAlert = function () {
            unlockScreen("alert");
            oldUI.closeAlert();
        }


        newUI.showLoading = function (text, cfg) {
            cfg = cfg || {};
            var newCfg = Util.extend(cfg, {});
            if (isNeedLock) {
                lockScreen("loading");
                newCfg.hideCb = function () {
                    unlockScreen("loading");
                    cfg.hideCb();
                }
            }
            oldUI.showLoading(text, newCfg);
        }

        newUI.hideLoading = function () {
            if (isNeedLock) {
                unlockScreen("loading");
            }
            oldUI.hideLoading();
        }
        newUI.showTips = function (str, cfg) {
            cfg = cfg || {};
            var newCfg = Util.extend(cfg, {});
            if (isNeedLock) {
                lockScreen("loading");
                newCfg.hideCb = function () {
                    unlockScreen("loading");
                    cfg.hideCb && cfg.hideCb();
                }
            }
            oldUI.showLoading(str, newCfg);
        }

        function lockScreen(fromType) {
    
            currLockType += fromType; // 叠加到字符串，unlock一个，清理一个
    
            try {
                stBeforeLock = Dom.window.document.body.scrollTop || document.body.scrollTop; // ios实际上是外层的才有效
                isShowing = true;
            } catch (e) { }
    
            var height = Dom.window.document.documentElement.clientHeight;
            document.body.firstElementChild.style.height = height + "px";
            document.body.firstElementChild.style.overflow = "hidden";
        }

        function unlockScreen(fromType) {
            if (isNeedLock) {
    
                if (fromType === "loading") { // loading 关掉的时候会全关，所以replace全部
                    currLockType = currLockType.replace(/loading/g, "");
                } else {
                    currLockType = currLockType.replace(fromType, "");
                }
    
                if (currLockType === "") {
                    document.body.firstElementChild.style.height = "";
                    if (stBeforeLock > 0 && isShowing === true) {
                        Dom.window.scrollTo(0, stBeforeLock);
                    }
                    document.body.firstElementChild.style.overflow = "";
                    isShowing = false;
                }
            }
        }

        function isNeedLockBodyHeight() {
            // return true;
            if (top != window && mweixin.isiOS) { // && Dom.hackIFrameEvent){
                return true;
            }
            return false;
        }
        exportData = newUI;
    })({});
}else{
    exportData = {
        alert: function(){},
        closeAlert: function(){},
        showLoading: function(){},
        hideLoading: function(){},
        showTips: function(){},
    };
}
export default exportData;